import { Injectable } from '@angular/core';
import axios, { AxiosRequestConfig, AxiosError } from 'axios';
import { environment } from '../../../environments/environment';
import { Observable, from, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RequestSambaService {
  private sambaToken: string;
  private sambaUrl: string;
  private sambaUploadUrl: string;

  constructor() {
    this.sambaToken = environment.sambaToken;
    this.sambaUrl = environment.sambaUrl;
    this.sambaUploadUrl = environment.sambaUploadUrl;
  }

  private prepareHeader() {
    return {
      Authorization: `Bearer ${this.sambaToken}`
    };
  }

  private handleError(error: AxiosError) {
    console.error(error);
    return throwError(() => error);
  }

  public post(endpoint: string, formData: any, options?: AxiosRequestConfig) {
    const headers = this.prepareHeader();

    const config: AxiosRequestConfig = {
      headers,
      ...options
    };

    if (endpoint.includes('upload')) {
      if (endpoint.includes('subtitles')) {
        return from(axios.post(`${this.sambaUrl}${endpoint}`, formData, config)).pipe(catchError(this.handleError));
      } else {
        return from(axios.post(`${this.sambaUploadUrl}${endpoint}`, formData, config)).pipe(
          catchError(this.handleError)
        );
      }
    } else {
      return from(axios.post(`${this.sambaUrl}${endpoint}`, formData, config)).pipe(catchError(this.handleError));
    }
  }
}
